const hasReference = (reference) => !!(reference && (reference.incidentId || reference.problemId));

const toReference = (reference) => ({
  incidentId: reference.incidentId ?? "",
  problemId: reference.problemId ?? "",
  description: reference.description ?? "",
});

// Every earlier incident this one repeats; falls back to the legacy single pastReferences for older records.
export const getPastReferencesList = (recurrence) => {
  const fromList = Array.isArray(recurrence?.pastReferencesList)
    ? recurrence.pastReferencesList.filter(hasReference).map(toReference)
    : [];
  if (fromList.length > 0) return fromList;
  return hasReference(recurrence?.pastReferences) ? [toReference(recurrence.pastReferences)] : [];
};

export const joinReferenceIds = (references, key = "incidentId") =>
  (references || []).map((reference) => reference?.[key]).filter(Boolean).join(", ");
